/** Route paths of the KPI commission dashboard, mounted under `/dashboard`. */
export class KpiCommissionRoutePaths {
  static readonly ROOT = "/dashboard/";
  static readonly KPI_COMMISSION = "kpi-commission";
}
